import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import OverlayContext from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import ThumbInfo from '@wix/da-shared-react/pkg/ThumbInfo';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import {
  getDeviationType,
  getDeviationResourceType,
} from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { normalizePremiumFolderData } from '@wix/da-shared-react/pkg/utils/normalizePremiumFolderData';
import DeviationPaywall from '../../_partials/paywalls/DeviationPaywall';

import s from './FeaturedDeviationThumb.scss';

export interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
}

export const FeaturedDeviationThumb: React.FC<Props> = ({
  deviation: { title, author, deviationId },
  deviation,
  width,
  height,
}) => {
  const { pointPrice, folderId } = normalizePremiumFolderData(
    deviation.premiumFolderData
  );

  return (
    <div className={s['root']}>
      <ErrorBoundary>
        <DeviationPaywall
          isLiterature={
            getDeviationType(deviation) === DeviationTypes.LITERATURE
          }
          premiumFolderData={deviation.premiumFolderData}
          contentOwner={author!}
          biData={{
            evid: BiEventType.GALLERY_PURCHASE,
            points: pointPrice,
            typeid: getDeviationResourceType(deviation),
            itemid: deviationId,
            galleryid: folderId,
            authorid: author && author.useridUuid, // This is NOT the gallery owner
          }}
        >
          <OverlayContext.Consumer>
            {value => (
              <OverlayContext.Provider
                value={{
                  ...value,
                  showAuthor: false,
                  showTitle: false,
                }}
              >
                <StandardThumb
                  deviation={deviation}
                  width={width}
                  height={height}
                />
              </OverlayContext.Provider>
            )}
          </OverlayContext.Consumer>
        </DeviationPaywall>
        <ThumbInfo urlDeviation={deviation} user={author!} title={title} />
      </ErrorBoundary>
    </div>
  );
};
FeaturedDeviationThumb.displayName = 'FeaturedDeviationThumb';

export default FeaturedDeviationThumb;
